import React, { FC } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { Price } from '../../../components/Price/Price';
import '../../../components/ui/Accordion/ReactAccessibleAccordion.css';
import { CATEGORY_DEFINITIONS } from '../../../constants/test-categories';
import { useTranslation } from '../../../hooks/useTranslation';
import { MainLocales } from '../../../locales/types';
import { Cost, TiranCostPayload } from '../../../types/api-types';
import styles from './Banner.module.scss';

interface Props {
  costs: Cost;
}

export const Banner: FC<Props> = ({ costs }) => {
  const { t } = useTranslation<MainLocales>('mainLocales');
  const costsPayload: TiranCostPayload = costs?.payload as TiranCostPayload;

  const Category1Link = () => (
    <a href='https://www.labor-tiran.at/patienteninformation/vorsorgeprofile-im-detail/'>
      {t('bookingFormTest_1_0_sublink')}
    </a>
  );

  const items = CATEGORY_DEFINITIONS.map(category => {
    if (category.uuid === 'Category-1') {
      return {
        uuid: category.uuid,
        rank: category.rank,
        heading: t(category.bookingHeadingKey as keyof MainLocales),
        content: (
          <div>
            <span className={styles.accordionHeadingSub}>
              {t(category.bookingSubKey as keyof MainLocales)}&nbsp;
              <Category1Link />
            </span>
            {category.items.map(({ name, bookingLabelKey }) => (
              <li key={name} className={styles.pricingLine}>
                <span className={styles.priceLineLabel}>
                  {t(bookingLabelKey as keyof MainLocales).split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {i === 1 ? <span className={styles.priceLineSub}>{line}</span> : line}
                      {i < 1 && <br />}
                    </React.Fragment>
                  ))}
                </span>
                <Price symbol={costs.currencySymbol} value={costsPayload[name]} />
              </li>
            ))}
          </div>
        ),
      };
    }

    return {
      uuid: category.uuid,
      rank: category.rank,
      heading: t(category.bookingHeadingKey as keyof MainLocales),
      content: (
        <div>
          {category.items.map(({ name, bookingLabelKey }) => (
            <li key={name} className={styles.pricingLine}>
              <span className={styles.priceLineLabel}>
                {t(bookingLabelKey as keyof MainLocales).split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {i === 1 ? <span className={styles.priceLineSub}>{line}</span> : line}
                    {i < 1 && <br />}
                  </React.Fragment>
                ))}
              </span>
              <Price symbol={costs.currencySymbol} value={costsPayload[name]} />
            </li>
          ))}
        </div>
      ),
    };
  });

  const rankedItems = items.slice().sort((a, b) => a.rank - b.rank);


  return (
    <div className={styles.banner}>
      <div className={styles.banner_left}>
        <img className={styles.logo} alt='logo' src={`/assets/tiran-lab-logo.png`} />
        <h4>{t('bannerHeader')}</h4>
        <Accordion
          allowMultipleExpanded={true}
          allowZeroExpanded={true}
          preExpanded={['Category-1']}
        >
          {rankedItems.map(item => (
            <AccordionItem
              key={item.uuid}
              uuid={item.uuid}
            >
              <AccordionItemHeading>
                <AccordionItemButton>{item.heading}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>{item.content}</AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>

        <h4>{t('bookingFormOptionalExtrasHeader')}</h4>
        {/*        REMOVE SAME-DAY SERVICE OPTION         */}
        {/*        <div className={styles.pricingLine}>
          <span>{t('bookingFormSameDayService')}</span>
          <Price symbol={costs.currencySymbol} value={costsPayload.sameDayService} sign />
        </div>
        */}
        {/*        REMOVE ATTEST OPTION         */}
        {/*<div className={styles.pricingLine}>
          <span>
            {t('bookingFormDoctorsNote')
              .split('\n')
              .map(text => (
                <span style={{ display: 'block' }} key={text}>
                  {text}
                </span>
              ))}
          </span>
          <Price symbol={costs.currencySymbol} value={costsPayload.englishResults} sign />
        </div>*/}
        <div className={styles.pricingLine}>
          <span>{t('bookingFormInvoiceExtrasHeader')}</span>
          <Price symbol={costs.currencySymbol} value={costsPayload.invoice} sign />
        </div>
      </div>
      <div className={styles.banner_right}>
        {/*<img alt='banner' src={`/assets/Laboratory-bro-tiran-colour.svg`} />*/}
        <div className={styles.image_container}>
          <img src={`/assets/Labor-Dr-Tiran-scaled-37.jpg`} alt='Labor Tiran' className={styles.framed_image}/>
        </div>
      </div>
    </div>
  );
};
